class BFCategoryBar extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.app = this.closest('bf-catalog');
    this.offers = this.app.querySelector('[data-bf-offers]');
    this.header = this.app.querySelector('.bf-topbar');
    this.toggle = this.querySelector('.bf-category-toggle');
    this.current = this.querySelector('[data-bf-current-category]');
    this.currentBadge = document.createElement('small');
    this.currentBadge.className = 'bf-category-discount';
    this.currentBadge.hidden = true;
    this.current.after(this.currentBadge);
    this.panel = this.querySelector('.bf-category-panel-grid');
    this.panel.id = 'bf-category-dropdown-' + (++BFCategoryBar.nextId);
    this.toggle.setAttribute('aria-controls', this.panel.id);
    this.chips = this.querySelector('.bf-category-chips');
    this.sections = [];
    this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden), { signal });
    this.panel.addEventListener('click', event => {
      if (event.target.closest('a')) this.setOpen(false);
    }, { signal });
    document.addEventListener('pointerdown', event => {
      if (!this.contains(event.target)) this.setOpen(false);
    }, { signal });
    document.addEventListener('focusin', event => {
      if (!this.contains(event.target)) this.setOpen(false);
    }, { signal });
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !this.panel.hidden) {
        event.preventDefault(); this.setOpen(false); this.toggle.focus();
      } else if (event.key === 'ArrowDown' && event.target === this.toggle) {
        event.preventDefault(); this.setOpen(true); this.panel.querySelector('a')?.focus();
      }
    }, { signal });
    this.schedule = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    };
    this.observer = new MutationObserver(() => this.build());
    this.observer.observe(this.offers, { childList: true });
    this.resize = new ResizeObserver(this.schedule);
    this.resize.observe(this.header);
    this.resize.observe(this);
    window.addEventListener('scroll', this.schedule, { passive: true, signal });
    window.addEventListener('resize', this.schedule, { passive: true, signal });
    this.build();
  }
  build() {
    this.sections = [...this.offers.querySelectorAll('.bf-category')];
    this.chips.replaceChildren();
    this.panel.replaceChildren();
    this.setOpen(false);
    for (const section of this.sections) {
      const title = section.querySelector('h2').textContent;
      const link = document.createElement('a');
      link.href = '#' + section.id;
      link.dataset.bfJump = section.id;
      const label = document.createElement('span');
      label.textContent = title;
      link.append(label);
      const source = [...this.app.querySelectorAll('[data-bf-links] a')].find(a => a.dataset.bfJump === section.id)?.querySelector('small');
      if (source && !source.hidden && source.textContent.trim()) {
        const badge = document.createElement('small');
        badge.className = 'bf-category-discount';
        badge.textContent = source.textContent;
        badge.setAttribute('aria-label', (this.app.config?.locale?.startsWith('ro') ? 'Reducere de până la ' : 'Up to ') + source.textContent.replace(/^[−–-]/, ''));
        link.append(badge);
      }
      this.chips.append(link);
      this.panel.append(link.cloneNode(true));
    }
    this.hidden = !this.sections.length;
    this.schedule();
  }
  update() {
    const headerHeight = getComputedStyle(this.header).position === 'sticky' ? this.header.getBoundingClientRect().height : 0;
    this.style.setProperty('--bf-category-top', headerHeight + 'px');
    const first=this.sections[0];
    this.classList.toggle('bf-mobile-nav-visible', !!first && first.getBoundingClientRect().bottom <= headerHeight + 80);
    const offset = headerHeight + (this.hasAttribute('data-sticky') && !this.hidden ? this.offsetHeight : 0) + 16;
    this.app.style.setProperty('--bf-category-offset', offset + 'px');
    let active = this.sections[0];
    for (const section of this.sections) {
      if (section.getBoundingClientRect().top <= offset + 40) active = section;
    }
    if (!active) return;
    const passedFirst = first && first.getBoundingClientRect().bottom <= offset + 40;
    this.current.textContent = passedFirst ? active.querySelector('h2').textContent : 'Vezi categoriile';
    const activeBadge = [...this.chips.children].find(a => a.dataset.bfJump === active.id)?.querySelector('.bf-category-discount');
    this.currentBadge.hidden = !passedFirst || !activeBadge;
    this.currentBadge.textContent = activeBadge?.textContent || '';
    this.currentBadge.setAttribute('aria-label', activeBadge?.getAttribute('aria-label') || '');
    for (const link of [...this.chips.children, ...this.panel.children]) {
      if (link.dataset.bfJump === active.id) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    }
  }
  setOpen(open) {
    this.panel.hidden = !open;
    this.toggle.setAttribute('aria-expanded', String(open));
  }
  disconnectedCallback() {
    this.currentBadge?.remove();
    this.abort?.abort(); this.abort = null;
    this.observer?.disconnect(); this.resize?.disconnect();
    cancelAnimationFrame(this.frame); this.frame = null;
    this.app?.style.removeProperty('--bf-category-offset');
  }
}
BFCategoryBar.nextId = 0;
if (!customElements.get('bf-category-bar')) customElements.define('bf-category-bar', BFCategoryBar);
